// Grayscale Script

export function greyScaleInit() {
	const grayscaleBtnElements = document.querySelectorAll(".jsGrayscaleToggle");
	if (grayscaleBtnElements.length === 0) {
		return;
	}

	const grayscaleClass = "grayscale";
	const grayscaleOnClass = "grayscale--on";
	const grayscaleFilterClass = "js-grayscale--filter";
	const grayscaleStorageKey = "colorThemeGrayscale"; // Unique storage key for grayscale

	const getSelectedGrayscaleTheme = () =>
		localStorage.getItem(grayscaleStorageKey);

	const setGrayscaleTheme = (theme) =>
		localStorage.setItem(grayscaleStorageKey, theme);

	// The filter goes on <html>. A CSS filter turns its element into a stacking context and a
	// containing block for fixed/absolute descendants, so putting it on header, main and footer
	// separately made <main> paint over the absolutely positioned transparent menu (and broke
	// fixed overlays inside <header>). The document root is exempt from that rule.
	// Never put it on <body>: body is not exempt, so position: fixed breaks there.
	const targetElements = [document.documentElement];

  const updateGrayscaleState = (isGrayscaleActive) => {
    // Apply or remove the filter class from target elements
    targetElements.forEach(element => {
      if (element) {
        element.classList.toggle(grayscaleFilterClass, isGrayscaleActive);
      }
    });

    // Update all toggle buttons
    grayscaleBtnElements.forEach((item) => {
      if (isGrayscaleActive) {
        item.classList.add(grayscaleOnClass, "active");
        item.setAttribute("title", item.getAttribute("data-active")); // name stays fixed, aria-pressed carries the state
        item.setAttribute("aria-pressed", "true");
      } else {
        item.classList.remove(grayscaleOnClass, "active");
        item.setAttribute("title", item.getAttribute("data-inactive"));
        item.setAttribute("aria-pressed", "false");
      }
    });
  };


	const grayscaleInitState = () => {
		const isGrayscaleActive = getSelectedGrayscaleTheme() === grayscaleClass;
		document.body.classList.toggle(grayscaleOnClass, isGrayscaleActive);
		updateGrayscaleState(isGrayscaleActive);
	};

	grayscaleInitState();

	// Ensure only one event listener is added per button
	const handleClick = (event) => {
		// console.log('Button clicked:', event.currentTarget);
		// Determine if grayscale is currently active
		const isGrayscaleActive = !document.body.classList.contains(grayscaleOnClass);

		// Toggle the grayscale state
		document.body.classList.toggle(grayscaleOnClass, isGrayscaleActive);
		updateGrayscaleState(isGrayscaleActive);
		setGrayscaleTheme(isGrayscaleActive ? grayscaleClass : "regular");
	};

	// Remove any existing event listeners to prevent duplication
	grayscaleBtnElements.forEach((button) => {
		button.removeEventListener("click", handleClick); // Ensure previous listeners are removed
		button.addEventListener("click", handleClick);
	});
}

export default greyScaleInit;